let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("aGy68")).then(() => parcelRequire('bqzz1'));